export default {
  body: `
    One more thing: even if you do not personally agree with the reason behind
    a question, please try to answer it.
  `,
  instruction: `
    Now, click the <b>Continue</b> button to hear the first question.
  `,
};
